import { useEffect } from 'react';
import { useModerationStore } from '@/store/moderationStore';
import { useIsAdmin } from '@/store/sessionStore';
import type { ModerationQueue } from '@/services/moderationQueue';

/**
 * Lo que espera en moderación, para el punto rojo y las solapas del panel.
 *
 * Sólo consulta si quien mira es admin: para cualquier otra persona no hace ni
 * un pedido. Y una sola vez por sesión, no una por componente — el estado vive
 * en un store compartido.
 *
 * Devuelve además `refresh` para que el panel vuelva a contar después de
 * resolver algo. Sin eso, el punto rojo seguiría marcando pendientes que ya no
 * existen.
 */
export function useModerationQueue(): ModerationQueue & { refresh: () => Promise<void> } {
  const isAdmin = useIsAdmin();
  const { fandomRequests, reports, total, loaded, refresh } = useModerationStore();

  useEffect(() => {
    if (isAdmin && !loaded) void refresh();
  }, [isAdmin, loaded, refresh]);

  if (!isAdmin) {
    return { fandomRequests: 0, reports: 0, total: 0, refresh };
  }

  return { fandomRequests, reports, total, refresh };
}
